import React from "react";
import styles from "./index.module.less";
import { useHistory, useLocation } from "react-router-dom";
import ZIcon from "@atoms/ZIcon";
import ZTypography from "@atoms/ZTypography";
import { EIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";
import { IBackButtonProps } from "./interface";

const { ZText } = ZTypography;

const BackButton: React.FC<IBackButtonProps> = props => {
	const history = useHistory();
	const location = useLocation();

	const goBack = () => {
		if (history.length > 2 && window.history.state !== null) {
			history.goBack();
		} else {
			const path = location.pathname;
			const parentPath = path.substring(0, path.lastIndexOf("/")) || "/";
			history.push(parentPath);
		}
	};

	return (
		<div
			id={props.id}
			className={`${
				styles.backButtonContainer
			} flex items-center mr-4 pr-4 border-0 ${
				!props.noBorder && !props.isMobileView ? "border-r" : ""
			} border-solid cursor-pointer -ml-4`}
			onClick={props.onClick ?? goBack}
		>
			<ZIcon
				name={EIcons.ARROWLEFT}
				color={EColors.BLUE}
				colorVariant={6}
				className="mr-2"
				size="sm"
			/>
			{!props.isMobileView && (
				<ZText color={EColors.BLUE} colorVariant={6}>
					{props.backText ?? "Back"}
				</ZText>
			)}
		</div>
	);
};

export default BackButton;
